import { format } from 'date-fns'
import React from 'react'
import { withTranslation } from 'react-i18next'
import {
	Bar,
	BarChart,
	CartesianGrid,
	Cell,
	Legend,
	Line,
	LineChart,
	Pie,
	PieChart,
	ReferenceArea,
	ResponsiveContainer,
	Tooltip,
	Treemap,
	XAxis,
	YAxis
} from 'recharts'
import { getAverage, getDimension, splitGroup } from '../helpers/utils'
import CustomTooltipContent from './CustomTooltipContent'

class ChartDetail extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			currentLevel: 1,
			currentSelections: [],
			refAreaLeft: '',
			refAreaRight: '',
		}
	}

	componentDidMount() {
		if (this.props.chart.api) {
			this.getValue()
		}
	}

	componentWillReceiveProps(props) {
		let dependsOn = props.dependsOn
		let changed
		// let body = (this.state && this.state.body) || '-'
		if (dependsOn && Object.keys(dependsOn).length) {
			if (this.state && this.state.dependsOn)
				changed = Object.keys(dependsOn).some(k => {
					if (dependsOn[k] !== this.state.dependsOn[k]) return true
					return false
				})
			else changed = true
		} else {
			changed = true
		}
		// body = this.processData(props)
		this.setState({ ...props, dependsOn })
	}
	getValue() {
		let { t } = this.props
		let api = this.props.chart.api
		let apiMeta
		if (this.props.chart.api) {
			let targetProp = api.response && api.response.targetProp
			targetProp = targetProp || 'charts.' + this.props.chart.name
			apiMeta = this.props.meta.apis && this.props.meta.apis[api]
			this.props.executeApi({ apiMeta, values: this.props.filterValues, targetProp, t })
		}
	}
	getDimensionData(props) {
		const { dimensionData, chart } = props
		let filteredData = getDimension({ data: dimensionData, filter: chart.dimension, metricName: chart.metricName })
		return filteredData
	}

	filterData(event) {
		const { chart } = this.props
		this.props.dimensionData &&
			this.props.dimensionData
				.filter(d => d[chart.dimension])[0]
				[chart.dimension].dim.filter(d => {
					d[0] = d[0] ? d[0] : 'NA'
					return d[0] === event.key
				})
		// this.props.dimensionData.filter(d => d[chart.dimension])[0][chart.dimension].group
		// .all()
		// .filter(d => d.key.includes(event.key))
		this.props.redrawAll()
	}

	onSeletion() {
		let { refAreaLeft, refAreaRight } = this.state
		console.log(refAreaLeft, refAreaRight)
		const { chart } = this.props
		if (refAreaLeft === refAreaRight || refAreaRight === '') {
			this.setState(() => ({
				refAreaLeft: '',
				refAreaRight: '',
			}))
			return
		}

		//console.log(refAreaLeft, refAreaRight, 'range select')
		//this.props.dimensionData.filter([refAreaLeft, refAreaRight]);
		this.props.dimensionData &&
			this.props.dimensionData
				.filter(d => d[chart.dimension])[0]
				[chart.dimension].dim.filter(d => {
					d[0] = d[0] ? d[0] : 'NA'
					return d[0] === refAreaLeft || d[0] === refAreaRight
				})
		this.props.redrawAll()
	}

	renderCustomizedLabel({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) {
		const radius = innerRadius + (outerRadius - innerRadius) * 0.5
		const RADIAN = Math.PI / 180
		const x = cx + radius * Math.cos(-midAngle * RADIAN)
		const y = cy + radius * Math.sin(-midAngle * RADIAN)

		return (
			<text x={x} y={y} fill="white" dominantBaseline="central">
				{`${(percent * 100).toFixed(2).replace(/[.,]00$/, '')}%`}
			</text>
		)
	}

	tickFormatter = value => {
		if (!value || value !== 'auto') {
			return format(new Date(value), 'dd MMM')
		} else {
			return value
		}
	}
	render() {
		const { chart, filterValues, t, tenantConfig } = this.props
		const { title, metrics, axes, series, stackNeeded } = chart
		const { refAreaRight, refAreaLeft } = this.state
		let dv = this.getDimensionData(this.props)

		let finalRows = []
		if (dv && dv.length) {
			if (chart.operator) {
				const averageRows = getAverage({ dim: dv[0][chart.dimension].dim })
				finalRows = averageRows.all().filter(function (kv) {
					return kv.key[Object.keys(kv.key).length - 1] === chart.metricName
				})
				finalRows = finalRows.map(r => {
					return {
						key: r.key[0],
						value: { ...r.value, [chart.operator]: parseInt(r.value[chart.operator].toFixed(2).replace(/[.,]00$/, '')) },
					}
				})
				finalRows = finalRows.filter(d => {
					return d.value[chart.operator] !== '0'
				})
			} else {
				let splitGroupData = splitGroup(dv[0][chart.dimension].group, chart)
				finalRows = splitGroupData
					.subgroup(chart.metricName)
					.all()
					.filter(d => {
						if (typeof d.value === 'object') {
							Object.keys(d.value).forEach(k => (d.value[k] === 0 ? delete d.value[k] : d.value[k]))
						}
						return typeof d.value === 'object' && Object.keys(d.value).length === 0 ? null : d.value
					})
			}
		}
		//console.log(finalRows, 'finalValue')
		const COLORS = ['#1abc9c', '#2ecc71', '#3498db', '#e67e22', '#FE9200', '#9b59b6', '#e74c3c', '#f39c12', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF']

		switch (chart.chartType) {
			case 'lines':
				/** have enough padding to show the titles and legends otherwise they are cut off */
				return (
					<div className="border my-2  py-2 shadow rounded">
						<h5 className="text-center"> {t(title) || 'Chart'} </h5>
						<ResponsiveContainer height={250} width="100%">
							<LineChart data={!finalRows || !finalRows.length ? [] : finalRows}>
								<CartesianGrid strokeDasharray="3 3" />
								<XAxis dataKey="key" tickFormatter={this.tickFormatter} />
								<YAxis />
								<Tooltip content={<CustomTooltipContent dataKey={chart.operator} t={t}/>} />
								<Line type="monotone" dataKey={`value.${chart.operator}`} stroke="#3498db" />
							</LineChart>
						</ResponsiveContainer>
					</div>
				)
			case 'bars':
				return (
					<div className="border my-2  py-2  shadow rounded">
						<h5 className="text-center"> {t(title) || 'Chart'} </h5>
						<ResponsiveContainer height={250} width={'100%'}>
							<BarChart
								data={!finalRows || !finalRows.length ? [] : finalRows}
								maxBarSize={50}
								onMouseDown={e => this.setState({ refAreaLeft: e.activeLabel })}
								onMouseMove={e => this.state.refAreaLeft && this.setState({ refAreaRight: e.activeLabel })}
								onMouseUp={this.onSeletion.bind(this)}>
								<CartesianGrid strokeDasharray="3 3" />
								<XAxis dataKey="key" />
								<YAxis />
								<Tooltip content={<CustomTooltipContent stackNeeded={stackNeeded} t={t}/>} />
								<Legend
									payload={
										stackNeeded
											? stackNeeded.map((item, index) => ({
													id: item.key,
													type: 'square',
													value: `${t(item.key)} (${finalRows.reduce((total, obj) => {
														return obj.value[item.key] ? total + obj.value[item.key] : total
													}, 0)})`,
													color: item.color,
											  }))
											: finalRows.map((item, index) => ({
													id: item.key,
													type: 'square',
													value: `${item.key}`,
													color: item.color || '#A68EF0',
											  }))
									}
								/>
								{stackNeeded ? (
									stackNeeded.map(entry => {
										return <Bar dataKey={`value.${entry.key}`} stackId="a" fill={entry.color} />
									})
								) : (
									<Bar dataKey="value" stackId="a" fill="#A68EF0" />
								)}
								{refAreaLeft && refAreaRight ? <ReferenceArea x1={refAreaLeft} x2={refAreaRight} strokeOpacity={0.3} /> : null}
							</BarChart>
						</ResponsiveContainer>
					</div>
				)
			case 'pie':
				// <Axis name="sold" title={axisTitle}/>
				return (
					<div className="border my-2  py-2 shadow rounded">
						<h5 className="text-center"> {t(title) || 'Chart'} </h5>
						<ResponsiveContainer height={250} width="100%">
							<PieChart>
								<Pie
									data={!finalRows || !finalRows.length ? [] : finalRows}
									labelLine={false}
									label={this.renderCustomizedLabel}
									outerRadius={80}
									fill="#8884d8"
									dataKey="value"
									onClick={e => this.filterData(e)}>
									{finalRows.map((entry, index) => (
										<Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
									))}
								</Pie>
								<Tooltip content={<CustomTooltipContent t={t}/>} />
								<Legend
									payload={finalRows.map((item, index) => ({
										id: item.key,
										type: 'square',
										value: `${t(item.key)} (${item.value})`,
										color: COLORS[index % COLORS.length],
									}))}
								/>
							</PieChart>
						</ResponsiveContainer>
					</div>
				)
			case 'treemap':
				if (!finalRows || !finalRows.length) {
					return <></>
				} else {
					return (
						<div className="border my-2  py-2 shadow rounded">
							<h5 className="text-center"> {t(title) || 'Chart'} </h5>
							<Treemap width={400} height={200} data={[]} dataKey="size" stroke="#fff" fill="#8884d8">
								<Tooltip />
							</Treemap>
						</div>
					)
				}
			default:
				return <></>
		}
	}
}
export default withTranslation()(ChartDetail)
